import { AppPaths, CloudflareAsset } from "@/shared/common/enums";
import { CloudFlareImage, LanguageSelect, UserMenu } from "@/shared/components";
import { Button } from "@ab.uitools/ui-library/components/Button";
import type { ISVGIconProps } from "@ab.uitools/ui-library/components/SVGIcons/types";
import type { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface Props {
  onOpen?: (isOpen: boolean) => void;
  isOpen?: boolean;
  setRef: Dispatch<SetStateAction<HTMLElement | null>>;
  getStopToolUrl: () => void;
}

export const Header = ({ onOpen, isOpen, setRef, getStopToolUrl }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="header">
      <div ref={setRef}>
        <CloudFlareImage
          className="header__hamburger cursor-pointer"
          path={CloudflareAsset.Hamburger}
          onClick={() => onOpen?.(!isOpen)}
        />
      </div>
      <CloudFlareImage
        className="header__logo cursor-pointer"
        path={CloudflareAsset.MyAmeriaLogo}
        onClick={() => navigate(AppPaths.Dashboard)}
      />
      <div className="flexbox align-items--center">
        <Button
          buttonText={t("general.stop")}
          type="tertiary"
          size="medium"
          className="stop-button mr-20"
          data-testid="stop-tool-url"
          data-ga-id="stop-tool-url"
          data-ga-action="Open stop tool url"
          onClick={() => getStopToolUrl()}
          iconProps={{
            Component: (props: ISVGIconProps) => (
              <CloudFlareImage {...props} path={CloudflareAsset.StopLight}/>
            ),
          }}
        />
        <UserMenu/>
        <LanguageSelect isLightIcon/>
      </div>
    </div>
  );
};
